import { create } from "zustand";
import { persist } from "zustand/middleware";

const useCartStore = create(
  persist(
    (set, get) => ({
      cart: [], // Ensure cart is initialized as an array

      // Add an item to the cart
      addItem: (itemId, title, price, description, beilage = "", customerComment = "") =>
        set((state) => {
          // Ensure cart is an array before performing operations
          const cart = Array.isArray(state.cart) ? state.cart : [];
          const existingItem = cart.find(
            (item) => item.id === itemId && item.beilage === beilage
          );
          if (existingItem) {
            return {
              cart: cart.map((item) =>
                item.id === itemId && item.beilage === beilage
                  ? { ...item, quantity: item.quantity + 1 }
                  : item
              ),
            };
          }
          return {
            cart: [
              ...cart,
              {
                id: itemId,
                title,
                price,
                description,
                beilage,
                customerComment,
                quantity: 1,
              },
            ],
          };
        }),

      // Increase quantity of an item
      increaseQuantity: (itemId, beilage) =>
        set((state) => {
          const cart = Array.isArray(state.cart) ? state.cart : [];
          return {
            cart: cart.map((item) =>
              item.id === itemId && item.beilage === beilage
                ? { ...item, quantity: item.quantity + 1 }
                : item
            ),
          };
        }),

      // Decrease quantity of an item
      decreaseQuantity: (itemId, beilage) =>
        set((state) => {
          const cart = Array.isArray(state.cart) ? state.cart : [];
          return {
            cart: cart
              .map((item) =>
                item.id === itemId && item.beilage === beilage
                  ? { ...item, quantity: item.quantity - 1 }
                  : item
              )
              .filter((item) => item.quantity > 0),
          };
        }),

      // Remove an item from the cart
      removeItem: (itemId, beilage) =>
        set((state) => {
          const cart = Array.isArray(state.cart) ? state.cart : [];
          return {
            cart: cart.filter(
              (item) => !(item.id === itemId && item.beilage === beilage)
            ),
          };
        }),

      // Total items in the cart
      totalItems: () => {
        const cart = Array.isArray(get().cart) ? get().cart : [];
        return cart.reduce((total, item) => total + item.quantity, 0);
      },

      // Total price of items in the cart
      totalPrice: () => {
        const cart = Array.isArray(get().cart) ? get().cart : [];
        return cart.reduce((total, item) => total + item.price * item.quantity, 0);
      },
      updateCustomerComment: (itemId, beilage, customerComment) =>
        set((state) => {
          const cart = Array.isArray(state.cart) ? state.cart : [];
          return {
            cart: cart.map((item) =>
              item.id === itemId && item.beilage === beilage
                ? { ...item, customerComment }
                : item
            ),
          };
        }),
        updateItem: (itemId, beilage, updatedProperties) =>
          set((state) => {
            const cart = Array.isArray(state.cart) ? state.cart : [];
            return {
              cart: cart.map((item) =>
                item.id === itemId && item.beilage === beilage
                  ? { ...item, ...updatedProperties }
                  : item
              ),
            };
          }),
        
    }),
    {
      name: "cart-storage", // Key in localStorage
    }
  )
);

export default useCartStore;
